import { FlagsManager } from '@databases/flags-types';

import {
  waitForContentAPI,
  type ContentAPI
} from '@canvas/frame-api/host-api/host-frame-context';
import { type ContentTypesFlagProps } from '@canvas/frame-api-types';

/**
 * A flags manager implementation that shows flags through the bridge API.
 */
export class BridgeFlagsManager extends FlagsManager {
  private contentAPI: ContentAPI | null = null;
  private shownFlagIds: Set<string> = new Set();

  private async initializeContentAPI() {
    if (!this.contentAPI) {
      this.contentAPI = await waitForContentAPI();
    }
  }

  async showFlag(props: ContentTypesFlagProps): Promise<void> {
    await this.initializeContentAPI();

    this.shownFlagIds.add(String(props.id));
    this.contentAPI?.confluenceAPI?.modals?.showFlag?.(props);
  }

  async hideFlag(flagId: number | string): Promise<void> {
    await this.initializeContentAPI();

    this.shownFlagIds.delete(String(flagId));
    this.contentAPI?.confluenceAPI?.modals?.hideFlag?.(String(flagId));
  }

  async hideAllFlags(): Promise<void> {
    await this.initializeContentAPI();

    for (const flagId of this.shownFlagIds) {
      this.contentAPI?.confluenceAPI?.modals?.hideFlag?.(flagId);
    }

    this.shownFlagIds.clear();
  }

  // Migration: old manager methods
  addFlag(): void {}
  clearFlags(): void {}
  handleFlagDismiss(): void {}
}
